module.exports = __webpack_public_path__ + "static/lifetimeHub2-b8b21b66bd879778bcece8fec470e0cb.jpg";